const HubIcon = ({ className }: any) => {
  return (
    <svg
      className={`text-tomato ${className}`}
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9991 13.1434C25.0529 8.82312 22.7778 4.80774 19.0431 2.63189C15.3084 0.456037 10.6915 0.456037 6.95689 2.63189C3.22222 4.80774 0.947069 8.82312 1.00094 13.1434C1.00094 18.0345 6.1 23.0426 9.23279 26.4071C10.3144 27.3416 11.6572 29.0003 13 29C14.3413 28.9997 15.7859 27.4574 16.7634 26.4084C19.9 23.0426 24.9991 18.0353 24.9991 13.1434Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.5H9.5C8.94772 17.5 8.5 17.0523 8.5 16.5V11.3502C8.5 10.7963 8.80529 10.2874 9.29405 10.0267L12.294 8.42651C12.7353 8.19116 13.2647 8.19116 13.706 8.42651L16.706 10.0267C17.1947 10.2874 17.5 10.7963 17.5 11.3502V12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 18H14.0625C13.7518 18 13.5 17.7482 13.5 17.4375V14.977C13.5 14.7743 13.541 14.5738 13.6207 14.3875L13.8378 13.8794C13.9361 13.6493 14.1623 13.5 14.4125 13.5H17.087C17.3372 13.5 17.5632 13.6492 17.6616 13.8792L17.8791 14.3876C17.9589 14.574 18 14.7747 18 14.9775V17.5C18 17.7761 17.7761 18 17.5 18Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 13.5V15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 17.5V15.5C18 15.2239 17.7761 15 17.5 15H14C13.7239 15 13.5 15.2239 13.5 15.5V17.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 11.5H14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 13.5H11C10.7239 13.5 10.5 13.7239 10.5 14V17.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.5H10.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HubIcon;
